import React, { useState, useEffect, useContext } from "react";
import axiosInstance from "../axiosInstance";
import AuthContext from "../AuthContext";
import Modal from "react-modal";
import FormForAdviser from "../components/FormForAdviser";
import { FaTimes, FaTimesCircle, FaCheckCircle, FaSmile } from "react-icons/fa";
import Pricing from "../components/Pricing";
import FormForWorker from "../components/FormForWorker";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const { loggedUser, isSubscriptionRequired, updateProfilePic } =
    useContext(AuthContext);
  const [AdviserModalIsOpen, setAdviserModalIsOpen] = useState(false);
  const [WorkerModalIsOpen, setWorkerModalIsOpen] = useState(false);
  const [workerFormDataToEdit, setWorkerFormDataToEdit] = useState(null);
  const [confirmDeleteModalIsOpen, setConfirmDeleteModalIsOpen] =
    useState(false);
  const [isSubscriptionDialogOpen, setIsSubscriptionDialogOpen] =
    useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [adviserFormDataToEdit, setadviserFormDataToEdit] = useState(null);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    role: "",
  });

  const [formData, setFormData] = useState({
    profileImage: null,
  });
  const [profilePreview, setProfilePreview] = useState(null);

  const [postToDelete, setPostToDelete] = useState(null);

  const [advisersPost, setAdvisersPost] = useState([]);
  const [workerPosts, setWorkerPosts] = useState([]);
  const [profileUploadedCompleted, setProfileUploadedCompleted] =
    useState(false);
    const [profileImageUpdating, setProfileImageUpdating] = useState(false);
  const navigate = useNavigate();

  // Fetch user details from localStorage
  useEffect(() => {
    const localUserData = JSON.parse(localStorage.getItem("user"));
    if (localUserData) {
      setUserData(localUserData);
    }
  }, []);

  useEffect(() => {
    fetchJobPostsDataByEmail();
  }, []);

  useEffect(() => {
    fetchLookingForWorkByEmail();
  }, []);

  const fetchJobPostsDataByEmail = async () => {
    const advisersResponse = await axiosInstance.get(
      `/api/findwork/advisersposts`,
      {
        params: {
          email: loggedUser.email,
        },
      }
    );
    setAdvisersPost(advisersResponse.data);
  };

  const fetchLookingForWorkByEmail = async () => {
    const lookingForWorkResponse = await axiosInstance.get(
      `/api/findworker/workerposts`,
      {
        params: {
          email: loggedUser.email,
        },
      }
    );
    setWorkerPosts(lookingForWorkResponse.data);
  };

  const handleWorkerDeletePost = async (postId) => { 
    try {
      await axiosInstance.delete(`/api/findwork/delete`, {
        data: {
          _id: postId,
        },
      });
      setWorkerPosts((prevPosts) =>
        prevPosts.filter((post) => post._id !== postId)
      );
      setMessage("Worker data deleted successfully");
      setMessageType("success");
    } catch (error) {
      setMessage("Error deleting worker data");
      setMessageType("error");
    } finally {
      setShowMessageModal(true);
    }
  };

  const handleWorkerEditPost = (post) => {
    setWorkerFormDataToEdit(post);
    setWorkerModalIsOpen(true);
  };

  // const handleWorkerEditPost = (post) => {

  const handleAdvisorFormSubmit = async (data) => {
    try {
      await axiosInstance.put(`/api/findworker/update`, {
        _id: data._id,
        ...data,
      });
      setMessage("Data updated successfully");
      setMessageType("success");
    } catch (error) {
      setMessage("Error updated the data");
      setMessageType("error");
    } finally {
      closeAdviserModal();
      setShowMessageModal(true);
    }
  };

  const openAdviserModal = () => {
    setAdviserModalIsOpen(true);
  };

  const closeAdviserModal = () => {
    setAdviserModalIsOpen(false);
  };

  const closeMessageModal = () => {
    setShowMessageModal(false);
    // Fetch the updated data
    fetchJobPostsDataByEmail();
  };

  const handleAdviserDeletePost = (postId) => {
    setPostToDelete(postId);
    setConfirmDeleteModalIsOpen(true); // Open confirmation modal
  };

  const closeConfirmDeleteModal = () => {
    setConfirmDeleteModalIsOpen(false);
  };

  const handleAdviserConfirmDelete = async () => {
    try {
      await axiosInstance.delete(`/api/findworker/delete`, {
        data: {
          _id: postToDelete,
        },
      });
      setMessage("Adviser data deleted successfully");
      setMessageType("success");
      // Filter out the deleted post
      setAdvisersPost((prevPosts) =>
        prevPosts.filter((post) => post.id !== postToDelete)
      );
    } catch (error) {
      setMessage("Error deleting adviser data");
      setMessageType("error");
    } finally {
      setConfirmDeleteModalIsOpen(false); // Close confirmation modal
      setShowMessageModal(true);
    }
  };

  const handleAdviserEditPost = (post) => {
    if (isSubscriptionRequired) {
      ShowSubscriptionDialogbox();
      return;
    }
    setadviserFormDataToEdit(post);
    openAdviserModal();
  };

  const ShowSubscriptionDialogbox = () => {
    setIsSubscriptionDialogOpen(true);
  };

  const closeSubscriptionDialog = () => {
    setIsSubscriptionDialogOpen(false);
  };

  const handleSubscriptionEvent = (eventType) => {
    if (eventType === "subscribe") {
      closeSubscriptionDialog();
    }
    if (eventType === "later") {
      closeSubscriptionDialog();
      // Handle later logic here
    }
  };
  const closeWorkerModal = () => {
    setWorkerModalIsOpen(false);
  };

  const handleWorkerFormSubmit = async (data) => {
    try {
      await axiosInstance.put(`/api/findwork/update`, data);
      setMessage("Data updated successfully");
      setMessageType("success");
      fetchLookingForWorkByEmail();
    } catch (error) {
      setMessage("Error creating worker data");
      setMessageType("error");
    } finally {
      closeWorkerModal();
      setShowMessageModal(true);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSizeMB = 10;
    if (file.size > maxSizeMB * 1024 * 1024) {
      setMessage(`Photo is too large. Please choose a smaller photo (under ${maxSizeMB}MB) or continue without changing it.`);
      setMessageType("error");
      setShowMessageModal(true);
      e.target.value = ""; // reset input
      return;
    }

    setProfileUploadedCompleted(false); // Reset profile upload status
    setFormData({
      ...formData,
      profileImage: file,
    });

    setProfilePreview(URL.createObjectURL(file)); // Set preview
  };

  const updateImage = async () => {
    try {
      setProfileImageUpdating(true);
      const formDataToSend = new FormData();
      formDataToSend.append("profileImage", formData.profileImage);
      const response = await axiosInstance.post(
        "/api/register/updateProfilePicture",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      updateProfilePic(response.data.profileImageUrl);

      setMessage("Profile image uploaded successfully");
      setMessageType("success");
      setProfileUploadedCompleted(true);
    } catch (error) {
      console.error("Error uploading image:", error);
      setMessage("Error uploading profile image");
      setMessageType("error");
    } finally {
      setProfileImageUpdating(false);
      setShowMessageModal(true);
    }
  };

  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-4xl">

      {/* ── PROFILE HERO ─────────────────────────────────────── */}
      <div className="relative bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-500 rounded-2xl shadow-xl mb-6 overflow-hidden">
        {/* Decorative blobs */}
        <div className="absolute top-0 left-0 w-48 h-48 bg-white rounded-full opacity-10 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full opacity-10 translate-x-1/4 translate-y-1/4 pointer-events-none" />

        <div className="relative p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6">
          {/* Avatar with camera overlay */}
          <div className="relative flex-shrink-0">
            <div className="w-32 h-32 rounded-full ring-4 ring-white shadow-xl overflow-hidden bg-indigo-300">
              <img
                src={
                  profilePreview ||
                  loggedUser.profileImage ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(userData.name || "U")}&background=6366f1&color=fff&size=128`
                }
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>
            <label
              htmlFor="profileImage"
              title="Change photo"
              className="absolute bottom-1 right-1 bg-white rounded-full p-2 shadow-md cursor-pointer hover:bg-indigo-50 transition"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <input
                type="file"
                name="profileImage"
                id="profileImage"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>
          </div>

          {/* Name / email / badges */}
          <div className="text-center sm:text-left">
            <h2 className="text-2xl sm:text-3xl font-bold text-white">{userData.name}</h2>
            <p className="text-indigo-200 text-sm mt-1">{userData.email}</p>
            <div className="flex flex-wrap gap-2 mt-3 justify-center sm:justify-start">
              {userData.role && (
                <span className="bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  {userData.role.charAt(0).toUpperCase() + userData.role.slice(1)}
                </span>
              )}
              {userData.location && (
                <span className="bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  📍 {userData.location}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Photo change confirmation bar */}
        {profilePreview && !profileUploadedCompleted && (
          <div className="relative bg-black/20 backdrop-blur px-6 py-3 flex items-center justify-between gap-4 border-t border-white/20">
            <div className="flex items-center gap-3">
              <img src={profilePreview} alt="Preview" className="w-10 h-10 rounded-full object-cover ring-2 ring-white" />
              <span className="text-white text-sm">New photo selected — ready to save</span>
            </div>
            <button
              onClick={updateImage}
              disabled={profileImageUpdating}
              className="bg-white text-indigo-600 font-semibold text-sm px-4 py-2 rounded-lg hover:bg-indigo-50 transition disabled:opacity-60"
            >
              {profileImageUpdating ? "Saving..." : "Save Photo"}
            </button>
          </div>
        )}

        {profileUploadedCompleted && (
          <div className="relative bg-green-500/20 px-6 py-2 flex items-center gap-2 border-t border-white/20">
            <FaCheckCircle className="text-green-300" />
            <span className="text-white text-sm font-medium">Profile photo updated!</span>
          </div>
        )}
      </div>

      {/* ── ACCOUNT DETAILS CARD ─────────────────────────────── */}
      <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 mb-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Account Details</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[
            { label: "Full Name", value: userData.name, icon: "👤" },
            { label: "Email", value: userData.email, icon: "✉️" },
            { label: "Phone", value: userData.phone, icon: "📞" },
            { label: "Location", value: userData.location, icon: "📍" },
          ].map(({ label, value, icon }) => (
            <div key={label} className="flex items-start gap-3 p-3 rounded-xl bg-gray-50 border border-gray-100">
              <span className="text-xl leading-none mt-0.5">{icon}</span>
              <div>
                <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">{label}</p>
                <p className="text-gray-800 font-medium">{value}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 mt-5">
          <button
            onClick={() => navigate("/change-password")}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition"
          >
            🔒 Change Password
          </button>
          {isSubscriptionRequired && (
            <button
              className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition"
              onClick={ShowSubscriptionDialogbox}
            >
              ⭐ Subscribe
            </button>
          )}
        </div>
      </div>
      {advisersPost.length > 0 && (
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">📋 Posted Jobs</h2>
          {advisersPost.map((post) => (
            <div
              key={post.id}
              className="mb-4 p-4 border border-gray-100 rounded-xl bg-gray-50 hover:shadow-md transition"
            >
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {post.job}
              </h3>
              <p className="text-gray-600 mb-4">
                <span className="font-bold">Posted on:</span>{" "}
                {new Date(post.postCreatedAt).toLocaleDateString("en-GB")}
              </p>
              <div className="flex flex-wrap space-x-2 mt-1">
                {Object.entries(post.availability).map(([day, available]) => (
                  <div className="mt-1">
                    <span
                      key={day}
                      className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                        available
                          ? "bg-green-200 text-green-800"
                          : "bg-red-200 text-red-800"
                      }`}
                    >
                      {day}
                    </span>
                  </div>
                ))}
              </div>
              <div className="flex space-x-4 mt-3">
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-5 rounded"
                  onClick={() => handleAdviserEditPost(post)}
                >
                  Edit Post
                </button>
                <button
                  className="bg-red-600 hover:bg-red-700 text-white py-2 px-5 rounded"
                  onClick={() => handleAdviserDeletePost(post._id)}
                >
                  Delete Post
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {workerPosts.length > 0 && (
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">🔍 Looking For Work Posts</h2>
          {workerPosts.map((post) => (
            <div
              key={post.id}
              className="mb-4 p-4 border border-gray-100 rounded-xl bg-gray-50 hover:shadow-md transition"
            >
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {post.job}
              </h3>
              <p className="text-gray-600 mb-4">
                <span className="font-bold">Posted on:</span>{" "}
                {new Date(post.postCreatedAt).toLocaleDateString("en-GB")}
              </p>
              <div className="flex flex-wrap space-x-2 mt-1">
                {Object.entries(post.availability).map(([day, available]) => (
                  <div className="mt-1">
                    <span
                      key={day}
                      className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                        available
                          ? "bg-green-200 text-green-800"
                          : "bg-red-200 text-red-800"
                      }`}
                    >
                      {day}
                    </span>
                  </div>
                ))}
              </div>
              <div className="flex space-x-4 mt-3">
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-5 rounded"
                  onClick={() => handleWorkerEditPost(post)}
                >
                  Edit Post
                </button>
                <button
                  className="bg-red-600 hover:bg-red-700 text-white py-2 px-5 rounded"
                  onClick={() => handleWorkerDeletePost(post._id)}
                >
                  Delete Post
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal
        isOpen={AdviserModalIsOpen}
        onRequestClose={closeAdviserModal}
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-auto max-h-[90vh] overflow-y-auto">
          <button
            onClick={closeAdviserModal}
            className="float-right text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
          <FormForAdviser
            existingData={adviserFormDataToEdit}
            onSubmit={handleAdvisorFormSubmit}
          />
        </div>
      </Modal>

      <Modal
        isOpen={WorkerModalIsOpen}
        onRequestClose={closeWorkerModal}
        contentLabel="Worker Form"
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-auto max-h-[90vh] overflow-y-auto">
          <button
            onClick={closeWorkerModal}
            className="float-right text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
          <FormForWorker
            existingData={workerFormDataToEdit}
            onSubmit={handleWorkerFormSubmit}
          />
        </div>
      </Modal>

      {/* Message Modal */}
      <Modal
        isOpen={showMessageModal}
        onRequestClose={closeMessageModal}
        contentLabel="Submission Status"
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div
          className={`bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto flex flex-col items-center ${
            messageType === "success" ? "border-green-500" : "border-red-500"
          } border`}
        >
          <button
            onClick={closeMessageModal}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
          {messageType === "success" ? (
            <FaCheckCircle size={48} className="text-green-500 mb-4" />
          ) : (
            <FaTimesCircle size={48} className="text-red-500 mb-4" />
          )}
          <h2 className="text-lg font-bold mb-2">
            {messageType === "success" ? "Success" : "Error"}
          </h2>
          <p className="text-center">{message}</p>
          <button
            onClick={closeMessageModal}
            className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Close
          </button>
        </div>
      </Modal>
      {/* Message Modal */}
      <Modal
        isOpen={showMessageModal}
        onRequestClose={closeMessageModal}
        contentLabel="Submission Status"
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div
          className={`bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto flex flex-col items-center ${
            messageType === "success" ? "border-green-500" : "border-red-500"
          } border`}
        >
          <button
            onClick={closeMessageModal}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          >
            <FaTimes size={20} />
          </button>
          {messageType === "success" ? (
            <FaCheckCircle size={48} className="text-green-500 mb-4" />
          ) : (
            <FaTimesCircle size={48} className="text-red-500 mb-4" />
          )}
          <h2 className="text-lg font-semibold text-center mb-2">{message}</h2>
          <button
            onClick={closeMessageModal}
            className={`mt-4 px-4 py-2 text-white ${
              messageType === "success" ? "bg-green-500" : "bg-red-500"
            } rounded hover:opacity-90`}
          >
            OK
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={confirmDeleteModalIsOpen}
        onRequestClose={closeConfirmDeleteModal}
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
          <h2 className="text-lg font-bold mb-4">Confirm Deletion</h2>
          <p>Are you sure you want to delete this post?</p>
          <div className="flex justify-end mt-6">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded mr-2"
              onClick={closeConfirmDeleteModal}
            >
              Cancel
            </button>
            <button
              className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded"
              onClick={handleAdviserConfirmDelete}
            >
              Confirm Delete
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isSubscriptionDialogOpen}
        onRequestClose={closeSubscriptionDialog}
        contentLabel="Subscription Dialog"
        className="fixed inset-0 flex items-center justify-center"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div
          className={`bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto flex flex-col items-center border-green-500border`}
        >
          <button
            onClick={closeSubscriptionDialog}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
          <div className={`text-4xl mb-4  text-green-500`}>
            <FaSmile />
          </div>
          <h3 className="font-bold mb-4">Subscription Now</h3>
          <div className="flex gap-4">
            <Pricing
              email={userData.email}
              laterButton={true}
              onEvent={handleSubscriptionEvent}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Profile;
